export default __webpack_public_path__ + "static/media/c2.361272ff.png";